module.exports = __webpack_public_path__ + "img/box-skins-blue34.f45f49ba.png";